import { Box } from "@mui/material";
import { GadgetFormatTable } from "./GadgetFormatTable";
import styles from "../css/GadgetIOFormatContainer.module.css";
import { FlattenedGadget } from "../../../models/GadgetModel";

interface GadgetIOFormatContainerProps {
    gadget: FlattenedGadget
}

export const GadgetIOFormatContainer = ({gadget}: GadgetIOFormatContainerProps) => {
    return (
        <Box className={styles.container}>
            <Box className={styles.ioFormatContainer}>
                <GadgetFormatTable headerText="Input Formats" fileFormats={gadget?.file_formats.inputs}/>
            </Box>
            <Box className={styles.ioFormatContainer}>
                <GadgetFormatTable headerText="Output Formats" fileFormats={gadget?.file_formats.outputs}/>
            </Box>
        </Box>
    );
}